import axios from 'axios'
import { Toast } from 'vant';
import Store from '@/store'
import { getAccessToken, setAccessToken, removeAllToken } from '@/utils/auth'

import Crypto from '@/utils/crypto'

function generateUUID() {
    const timestamp = Date.now().toString(16);
    const random = Math.random().toString(16).slice(2);
    return `${timestamp}-${random}`;
}

/**
 * 加载环境变量
 */
axios.defaults.withCredentials = false;

console.log(process.env.NODE_ENV)
const service = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/api',
    withCredentials: false,
    timeout: 30000,
});
window.axiosCalcelTokenArr = [];
// 请求前拦截

service.interceptors.request.use(
    config => {
        console.log(config)
        if (!config.data) {
            config.data = { _: new Date().getTime() }
        }

        let currentTime = new Date().getTime();
        let secretClient = 'oewioewgoijpghrporeghpwueoreloikweiokeweekqqierijfd';
        let cipherStr = Crypto.encrypt(currentTime + "#" + secretClient, secretClient);

        console.log('客户端密钥:' + secretClient);
        console.log('客户端时间戳:' + currentTime);
        console.log('客户端密文:' + cipherStr);

        config.headers['egewg-key'] = 'rigewjgewgewhiofee';
        config.headers['x-timestamp'] = currentTime;
        config.headers['x-ciphertext'] = cipherStr;

        // config.headers['Content-Type'] = 'application/json;'
        // config.headers['Cache-Control'] = 'no-cache';

        //let uuid = generateUUID();

        config.headers['uta-lrm-jev'] = '0a97411e-7216-4c25-84dc-7f8853d3bec1';
        config.headers['wxq-fcy-qvd'] = 'Superpwa'; //media_source
        config.headers['uqf-sqc-rdb'] = '11'; //app_version
        config.headers['aif-efb-bad'] = '59'; //app_version_code
        config.headers['wji-snl-bsh'] = ''; //imei1
        config.headers['gsg-vcr-spf'] = ''; //firebase_id 8819a314331fd1288124da582385a03c
        config.headers['frg-wpc-sbq'] = '3'; //network
        config.headers['pik-hit-iyd'] = ''; //campaign
        config.headers['lmj-uvg-ljo'] = '1745390990025-6134478757746957813'; //appsflyer_id
        config.headers['jym-rsn-icx'] = 'sdk_gphone64_arm64'; //model
        config.headers['hvc-ann-cnl'] = ''; //city
        config.headers['tul-pwd-xwf'] = '-1'; //latitude
        config.headers['alh-sjc-mfj'] = '14'; //os
        //config.data.bwd_irh_lnf = "Asia/Shanghai"; //time_zone
        config.headers['ecc-eda-hca'] = 'c641c796-2008-4cf4-8476-c8a79e2fe001'; //google_advertising_id
        config.headers['aer-rbs-pxr'] = '0'; //is_simulator
        config.headers['xbe-nxb-kfr'] = '-1'; //longitude
        config.headers['vaz-mtl-mvo'] = 'y55ldjvCPvthbL2NOju7KqOVStXQbnn43tcJGH2_4EA='; //imei
        config.headers['mqh-qef-wkr'] = 'e47a0dR6QfeQU_r3Aee0wR:APA91bHbd4HGJ8Z3b_VILG48DcmJRRUpCNzZkyFCrHQVeMNYgPYCAf3anAjIK_vXScUzIO-E8d_2ad-okfNjmV8-hhyHB2MHAAAQOCogtLeCzr3ODdIjOas'; //fcm_token
        config.headers['wdb-igv-mvy'] = ''; //imei2
        config.headers['dkx-hed-raz'] = ''; //af_channel
        config.headers['yoj-net-zzx'] = 'google'; //brand
        config.headers['doe-ody-zty'] = '9E48AF9EFA33FCB114BD45436BE17380'; //mobId
        config.headers['csb-ggc-uyo'] = 'h5'; //platform
        config.headers['ega-caf-hbe'] = '1'; //is_google_service
        //sconfig.data.xfo_plp_van = ''; //ip
        config.headers['rdn-sge-rrm'] = ''; //agency
        config.headers['kvk-jjy-tsv'] = 'Superpwa'; //source

        config.data.ckn_emo_hfg = currentTime; //request_time
        // config.data.aaa_off_csl = ''; //noise
        // config.data.zzm_yya_hqb = ''; //access_token
        // config.data.bac_fcc_gdc = ''; //signature

        console.log(config.headers)
        return config
    },
    error => {
        return Promise.reject(error)
    }
);



const successRes = res => {
    // 接口请求成功
    return res.data
};
const successChange = res => {
    // 删除，修改记录成功
    return res.data
};
const warning = res => {
    // 请求失败，字段缺失
    Toast(res.data.ms);
    return Promise.reject(res.data.ms)
};
const danger = res => {
    // 请求失败，原因message
    console.log(res);
    let error = null;
    try {
        let _message = 'Excepción de red'; //  网络异常
        let code = '0';
        if (res.data) {
            _message = res.data.ms || 'Excepción de red'
            //_message = 'Excepción de red'
            code = res.data.ci || 0
        }
        error = new Error(_message);
        error.code = code;

        if (!isSilence(res)) {
            if(code != 400116){
                Toast.fail(_message)
            }
        }

        console.error(error);
        if (res.data.da) {
            console.error(res.data.da)
        }
    } catch (err) {
        error = err
    }
    return Promise.reject(error)
};


const isSilence = (res) => {
    let requestParams = {};
    try {
        requestParams = Object.assign({}, res.config.params || {}, JSON.parse(res.config.data || '{}'))
    } catch (error) {
        console.log(error);
    }
    return !!requestParams['silence']
};

const loginout = () => {
    Store.commit('common/SET_ACCESS_TOKEN', '');
    Store.commit('common/SET_COUPONS', null);
    Store.commit('common/SET_LOANA_AMOUNT', '');
    Store.commit('common/SET_LOAN_DAYS', null);
    Store.commit('common/SET_BANK_DATA', null);
    Store.commit('common/SET_ISREPEAT_LOAN', false);

    localStorage.clear();

};

// 响应拦截
service.interceptors.response.use(
    res => {
        console.log(res)
        if (res.data instanceof Blob) {
            return res.data;
        }

        switch (res.data.ci) {
            case 0:
                return successRes(res);
            case 200:
                return successRes(res);
            case 400114:
                return loginout()
            case 201:
                return danger(res);
            case 202:
                return danger(res);
            case 203:
                return danger(res);
            case 204:
                return danger(res);
            case 301:
                return danger(res);
            case 302:
                return danger(res);
            default:
                return danger(res)
        }
    },
    err => {
        // 处理403 重新登录逻辑
        Toast.fail(`Excepción de red, inténtelo de nuevo más tarde.`); //网络异常，请稍后再试
        console.log(err)
        return Promise.reject(err)
    }
);

export default service

